import React from 'react';
import { compose, lifecycle, withState } from 'recompose';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Checkbox } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import { attributeValueGet } from '../../app/_api';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Select } from 'redux-form-material-ui';
import { get, sortBy } from 'lodash';
import { itemStatus } from '../../../utils/constants';

const styles = (theme) => ({});
const selector = formValueSelector('addItemForm');
const number = (value) => (value && isNaN(Number(value)) ? 'Musí být číslo' : undefined);

const enhance = compose(
  withStyles(styles),
  withRouter,
  withState('attrValues', 'setAttrValues', []),
  connect((state) => ({
    multi: selector(state, 'multi'),
  })),
  lifecycle({
    async componentDidMount() {
      const { setAttrValues } = this.props;
      const resp = await attributeValueGet(18);
      if (resp) {
        setAttrValues(get(resp, 'items', []));
      }
    },
  }),
  reduxForm({ form: 'addItemForm' })
);

export default enhance(
  ({
    classes,
    handleSubmit,
    attributes,
    history,
    setAdd,
    multi,
    add,
    productId,
    attrValues,
    category,
  }) => (
    <form className={classes.form} onSubmit={handleSubmit}>
      <h3>{add ? 'Přidat položku' : 'Upravit položku'}</h3>
      <Grid container spacing={8}>
        <Grid item xs={12}>
          <Field
            name="price"
            component={TextField}
            label="Pořizovací cena"
            className={classes.textFields}
            validate={[number]}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            name="serialNumber"
            component={TextField}
            label="Sériové číslo"
            className={classes.textFields}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl style={{ minWidth: 200 }}>
            <InputLabel htmlFor={'status'}>Stav</InputLabel>
            <Field name={`status`} component={Select} placeholder={'status'}>
              {itemStatus
                .sort((a, b) => (a.value > b.value) - (a.value < b.value))
                .map((item2) => (
                  <MenuItem key={item2.id} value={item2.id}>
                    {item2.label}
                  </MenuItem>
                ))}
            </Field>
          </FormControl>
        </Grid>
        {attributes &&
          attributes.length > 0 &&
          attributes.map((attr) => (
            <Grid key={attr.id} item xs={12}>
              <FormControl style={{ minWidth: 200 }}>
                <InputLabel htmlFor={attr.id}>{attr.name}</InputLabel>
                <Field name={`attributes.${attr.id}`} component={Select} placeholder={attr.name}>
                  {get(attr, 'valueTypes', []).includes('int') &&
                  get(attr, 'valueTypes', []).length === 1
                    ? attr.values
                        .sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10))
                        .map((item2) => (
                          <MenuItem key={item2.id} value={item2.id}>
                            {item2.value}
                          </MenuItem>
                        ))
                    : sortBy(attr.values, ['value']).map((item2) => (
                        <MenuItem key={item2.id} value={item2.id}>
                          {item2.value}
                        </MenuItem>
                      ))}
                </Field>
              </FormControl>
            </Grid>
          ))}
        {add && (
          <Grid item xs={12}>
            <FormControlLabel
              control={<Field name="multi" component={Checkbox} />}
              label="Přidat vícekrát"
            />
          </Grid>
        )}
        {multi && (
          <Grid item xs={12}>
            <Field
              name="count"
              component={TextField}
              label="Počet"
              className={classes.textFields}
              validate={[number]}
            />
          </Grid>
        )}
      </Grid>
      <div style={{ marginTop: 20 }}>
        <Button type="submit" variant="contained" color="primary" className={classes.submit}>
          Uložit
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            add ? setAdd(false) : history.push(`/products/${productId}`);
          }}
        >
          Zrušit
        </Button>
      </div>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/products/form/addItemForm.js